import { Schema } from "effect";

export const CopyMessagesSchema = Schema.Record(
  Schema.String,
  Schema.Record(Schema.String, Schema.String),
);

export const CopyResponseSchema = Schema.Struct({
  messages: CopyMessagesSchema,
  fetchedAt: Schema.optional(Schema.String),
});

export type CopyResponse = typeof CopyResponseSchema.Type;
